import React from "react";
import PropTypes from "prop-types";
import "../../css/Cards/CardReference.css";
import Image from "../ImageElement";
import ChevronUp from "../../svg/ICON_chevronUP_Dark.svg";
import ChevronDown from "../../svg/ICON_chevronDown_Dark.svg";

/**
 * CardReference component
 */
class CardReference extends React.Component {
  static displayName = "CardReference";
  static propTypes = {
    className: PropTypes.string,
    reference: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardReference";
    this.maxLen = 300;

    this.state = {
      open: false,
      isSmall:
        props.reference.Text.length < this.maxLen &&
        props.reference.sections().reduce((sum, x) => {
          return sum + x.images().size;
        }, 0) < 1,
    };

    this.cropText = this.cropText.bind(this);
  }

  /**
   * Count characters and cut if needed
   * @param  {string} text Text to count on
   * @return {string}      cut text
   */
  cropText(text) {
    if (text.length > this.maxLen) {
      return text.slice(0, this.maxLen) + "...";
    }
    return text;
  }

  /**
   * @override
   */
  render() {
    if (!this.props.reference) return false;
    const reference = this.props.reference;
    return (
      <div
        className={`${this.className} ${this.props.className || ""} ${
          this.state.open ? "open" : "close"
        }`}
      >
        <div className={`${this.className}__content`}>
          <div className={`${this.className}__images`}>
            <Image
              src={reference.cover()[`${this.props.screen}_src`]}
              alt={reference.cover().alt}
            />
            {this.props.screen === "desktop" &&
              reference.sections().map((section) => {
                return (
                  <div className={`${this.className}__imgs`} key={section.ID}>
                    {section.images().map((image) => {
                      return (
                        <Image
                          className={
                            image.isLandscape ? "landscape" : "portrait"
                          }
                          key={image.ID}
                          src={image[`${this.props.screen}_src`]}
                          alt={image.alt}
                        />
                      );
                    })}
                  </div>
                );
              })}
          </div>
          <div className={`${this.className}__right`}>
            <div>
              <div className={`${this.className}__text`}>
                <h1
                  className={`${this.className}__title`}
                  dangerouslySetInnerHTML={{
                    __html: reference.Title,
                  }}
                />
                <div
                  className={`${this.className}__html`}
                  dangerouslySetInnerHTML={{
                    __html: this.state.open
                      ? reference.Text
                      : this.cropText(reference.Text),
                  }}
                />
              </div>
            </div>
            {this.props.screen === "mobile" && (
              <div className={`${this.className}__images`}>
                {reference.sections().map((section) => {
                  return (
                    <div className={`${this.className}__imgs`} key={section.ID}>
                      {section.images().map((image) => {
                        return (
                          <Image
                            className={
                              image.isLandscape ? "landscape" : "portrait"
                            }
                            key={image.ID}
                            src={image[`${this.props.screen}_src`]}
                            alt={image.alt}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}

            {!this.state.isSmall && (
              <div
                className={`${this.className}__close`}
                onClick={() => this.setState({ open: !this.state.open })}
              >
                {this.state.open ? "Fermer" : "Ouvrir"}
                <img
                  src={this.state.open ? ChevronUp : ChevronDown}
                  alt="Up"
                  className="icon"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default CardReference;



// WEBPACK FOOTER //
// ./src/components/Cards/CardReference.js